import {post} from './axios'
import configUrl from '@/libs/config';

export default {
    goodsPaging(prams) {
        return post('/api/goods/paging', prams)
    },

    advertisingList(prams) {
        return post('/api/advertising/list', prams)
    },

    member(prams) {
        // alert(222)
        return post('/api/member/parse', prams)
    },

    myTeam(prams) {
        return post('/api/myTeam/paging', prams)
    },

    myOrder(prams) {
        return post('/api/myOrder/paging', prams)
    },

    show(prams) {
        return post('/api/profitCenter/show', prams)
    },


    invitation(prams) {
        return post('/api/joinCommunity/invitation', prams)
    },

    wxConfig(prams) {
        return post('/common/moduleInfo/wxConfig', prams)
    },

    joinCommunity(prams) {
        return post('/api/joinCommunity/join', prams, '1')
    },

    level(prams) {
        return post('/api/level/show', prams)
    },

    shareShow(prams) {
        return post('/api/shareGoodsPoster/shareShow', prams)
    },

    communityInfo(prams) {
        return post('/common/moduleInfo/communityInfo', prams)
    },

    taskList(prams) {
        return post('/api/task/paging', prams)
    },
    taskDetail(prams) {
        return post('/api/task/stepDetail', prams)
    },
    taskPkDetail(prams) {
        return post('/api/task/pkDetail', prams)
    },
    taskOrderList(params){
        return post('/api/task/taskOrderpaging', params)
    },
    taskPkRank(params){
        return post('/api/task/pkRank', params)
    },
    taskMyPkRank(params){
        return post('/api/task/myPkRank', params)
    },
    taskReceive(params){
        return post('/api/task/receive', params)
    },
    taskFirstDetail(params){
        return post('/api/task/firstDetail', params)
    },
    taskResaleDetail(params){
        return post('/api/task/resaleDetail', params)
    },
    goodsDetail(params){
        return post('/common/goods/goodsDetail', params)
    },
    assistant(params) {
        return post(configUrl.config().newAuth + '/token/assistant', params)
    },
    goodsDetail2(params){
        return post('/api/goods/detail', params)
    },
    goodsBargain(params){
        return post('/api/bargain/goodsBargain', params)
    },
    helpRecordList(params){
        return post('/api/bargain/helpRecordList', params)
    },
    explain(params){
        return post('/api/goods/explain', params)
    },
    xitongkanjia(params){
        return post('/api/bargain/bargain', params)
    },
    aide(params){
        return post('/api/member/aide', params)
    },
    helpBargain(params){
        return post('/api/bargain/helpBargain', params)
    },
    bargainShare(params){
        return post('/api/bargain/bargainShare', params)
    },
    bargainRecordInfo(params){
        return post('/api/bargain/bargainRecordInfo', params)
    },
    myBargainRecord(params){
        return post('/api/bargain/myBargainRecord', params)
    },
    bargainOrder(params){
        return post('/api/myOrder/bargainOrder', params)
    },
    orderCancel(params){
        return post('/api/myOrder/orderCancel', params)
    },
    imgToBase64(params){
        return post('/common/upload/imgToBase64', params)
    },
    isFollow(params){
        return post('/common/moduleInfo/isFollow', params)
    },
    introduce(params){
        return post('/common/goods/introduce', params)
    },
    yaopin(params){
        return post('/common/goods/marketingConfigPaging', params)
    },

    //商品详情页查询子商品
    getCommonSubGoodsList(params){
        return post('/common/goods/goodsSubDetail', params)
    },
     //商品详情页查询子商品
    getSubGoodsList(params){
        return post('/api/goods/subDetail', params)
    },
}
